import { App } from '@/types/applications'
import { AppComponent } from './app'

export const TCSApplications = ({
  applications,
  navigatePath,
}: {
  applications: App[],
  navigatePath: string
}) => {

  return (
    <div className="applicationGrid flex flex-wrap" >
      {applications.length && applications.map((app, i) => (
        <AppComponent
          key={i}
          app={app}
          navigatePath={navigatePath}
        />
      ))}
    </div>
  )
}
